import React from "react";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import { makeStyles } from "@mui/styles";
import { Link } from "react-router-dom";
import Typography from "@mui/material/Typography";
import Fade from "react-reveal/Fade";
import { useTranslation } from "react-i18next";

const IndexPicture = () => {
  const classes = useStyles();
  // const { t, i18n } = useTranslation();
  const { t, i18n } = useTranslation();
  return (
    <Box
      className={classes.Navbar}
      position="static"
      sx={{
        maxWidth: "1900px",
        minHeight: "750px",
        backgroundPosition: {
          md: "bottom 20px right -70px",
          sm: "bottom 20px right -410px",
          xs: "bottom 20px right -570px",
        },
      }}
    >
      <Grid
        container
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Grid
          item
          sx={{
            width: "90%",
          }}
        >
          <Grid
            container
            style={{
              display: "flex",
              alignItems: "center",
              paddingLeft: "2%",
              paddingRight: "2%",
              minHeight: "700px",
            }}
          >
            <Grid item xs={12}>
              <Typography
                sx={{
                  fontSize: "15px",
                  paddingBottom: "10px",
                }}
              >
                <Fade bottom delay={600}>
                  HESLET stands for
                </Fade>
              </Typography>

              <Box
                sx={{
                  zIndex: 100,
                  lineHeight: "1.4em",
                  fontSize: "40px",
                  fontWeight: 500,
                }}
              >
                <Fade bottom delay={600}>
                  Health, Safety, Technology
                </Fade>
                <Fade bottom delay={700}>
                  and Environment
                </Fade>
              </Box>
              <Box sx={{ fontSize: "16px", pt: 2, pb: 2, color: "#5d6163" }}>
                <Fade bottom delay={700}>
                  {t("indexPage")}
                </Fade>
              </Box>

              <Fade bottom delay={800}>
                <Button
                  className="custom_btn"
                  component={Link}
                  to={"/products-cleansing"}
                  // color="secondary"
                  variant="contained"
                  sx={{
                    backgroundColor: "#153a5b",
                    py: 1,
                    px: 5,
                    mt: 2,
                    fontSize: "14px",
                    width: "200px",
                    boxShadow: "none",
                    borderRadius: 0,
                  }}
                >
                  {t("shopNow")}
                </Button>
              </Fade>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default IndexPicture;

const useStyles = makeStyles({
  Navbar: {
    padding: 0,
    margin: 0,
    display: "flex",
    backgroundColor: "white",
    flexDirection: "column",
    // color: "rgb(83, 90, 91)",
    // backgroundImage: `url("img/atoms-C3rI_Fy84Wc-unsplash.jpg")`,
    // backgroundImage: `url("https://images.unsplash.com/photo-1481091634437-564d831a73df?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=830&q=80")`,
    // backgroundImage: `url("https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80")`,
    backgroundImage: `url("https://images.unsplash.com/photo-1560707854-fb9a10eeaace?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80")`,

    backgroundRepeat: "no-repeat",
    color: "#153a5b",
    backgroundSize: "1100px",
  },

  Navbar__menu: { color: "#153a5b", border: "1px solid black", zIndex: 100 },
});
